// AddPaymentView.jsx
import React, { useState } from "react";
import { ChevronLeft } from "lucide-react";
import "./AddPaymentView.css";

const AddPaymentView = ({ onBack }) => {
  const [cardNumber, setCardNumber] = useState("");
  const [expiry, setExpiry] = useState("");
  const [cvv, setCvv] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [street, setStreet] = useState("");
  const [postcode, setPostcode] = useState("");
  const [city, setCity] = useState("");
  const [region, setRegion] = useState("");
  const [phone, setPhone] = useState("");

  // Format credit card number as '1234 5678 9012 3456'
  const formatCardNumber = (value) => {
    const digits = value.replace(/\D/g, "").slice(0, 16);
    return digits.replace(/(.{4})/g, "$1 ").trim();
  };

  const handleCardNumberChange = (e) => {
    setCardNumber(formatCardNumber(e.target.value));
  };

  // Format expiry as 'MM YYYY'
  const formatExpiry = (value) => {
    const digits = value.replace(/\D/g, "").slice(0, 6);
    if (digits.length <= 2) return digits;
    return digits.slice(0, 2) + ' ' + digits.slice(2);
  };

  const handleExpiryChange = (e) => {
    setExpiry(formatExpiry(e.target.value));
  };

  // CVV numeric only
  const handleCvvChange = (e) => {
    setCvv(e.target.value.replace(/\D/g, "").slice(0, 4));
  };

  return (
    <div className="add-payment-container">
      <button className="back-btn" onClick={onBack}>
        <ChevronLeft size={20} />
        <span>Back</span>
      </button>

      <div className="section-header">
        <h1>Add Payment</h1>
        <hr />
      </div>

      <div className="payment-type-card">
        <div className="payment-type-icon">💳</div>
        <div className="payment-type-details">
          <div className="type-title">Credit / Debit Card</div>
          <div className="type-subtitle">Visa, MasterCard, American Express</div>
        </div>
      </div>

      <div className="form-card">
        <div className="section-label">Card Details</div>
        <div className="form-row">
          <label htmlFor="card-number">Number</label>
          <input
            id="card-number"
            type="text"
            inputMode="numeric"
            placeholder="Required"
            value={cardNumber}
            onChange={handleCardNumberChange}
          />
        </div>
        <div className="form-row">
          <label htmlFor="card-exp">Expires</label>
          <input
            id="card-exp"
            type="text"
            inputMode="numeric"
            placeholder="MM YYYY"
            value={expiry}
            onChange={handleExpiryChange}
          />
        </div>
        <div className="form-row">
          <label htmlFor="card-cvv">CVV</label>
          <input
            id="card-cvv"
            type="text"
            inputMode="numeric"
            placeholder="Security code"
            value={cvv}
            onChange={handleCvvChange}
          />
        </div>
      </div>

      <div className="form-card">
        <div className="section-label">Billing Name</div>
        <div className="form-row">
          <label htmlFor="first-name">First Name</label>
          <input
            id="first-name"
            type="text"
            placeholder=""
            value={firstName}
            onChange={(e) => setFirstName(e.target.value)}
          />
        </div>
        <div className="form-row">
          <label htmlFor="last-name">Last Name</label>
          <input
            id="last-name"
            type="text"
            placeholder=""
            value={lastName}
            onChange={(e) => setLastName(e.target.value)}
          />
        </div>
      </div>

      <div className="form-card">
        <div className="section-label">Billing Address</div>
        <div className="form-row">
          <label htmlFor="street">Street</label>
          <input
            id="street"
            type="text"
            placeholder=""
            value={street}
            onChange={(e) => setStreet(e.target.value)}
          />
        </div>
        <div className="form-row">
          <label htmlFor="postcode">Postcode</label>
          <input
            id="postcode"
            type="text"
            inputMode="numeric"
            placeholder=""
            value={postcode}
            onChange={(e) => setPostcode(e.target.value)}
          />
        </div>
        <div className="form-row">
          <label htmlFor="city">City</label>
          <input
            id="city"
            type="text"
            placeholder=""
            value={city}
            onChange={(e) => setCity(e.target.value)}
          />
        </div>
        <div className="form-row">
          <label htmlFor="region">County/Region</label>
          <input
            id="region"
            type="text"
            placeholder=""
            value={region}
            onChange={(e) => setRegion(e.target.value)}
          />
        </div>
        <div className="form-row">
          <label htmlFor="phone">Phone</label>
          <input
            id="phone"
            type="text"
            inputMode="tel"
            placeholder=""
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
          />
        </div>
      </div>

      <button className="done-btn">Done</button>
    </div>
  );
};

export default AddPaymentView;
